module.exports = __webpack_public_path__ + "static/media/logo-clinica-sim.e8f07b53.png";